import type { WheelNode } from "../../types/geneCodes/geneticWheel";

// Legacy brightstarD3.js:158 uses `.some()`, so N matching interventions are still one hit per SNP.
export const matchedInterventions = (
	rs: string | null | undefined,
	map: Map<string, string[]>,
	selected: string[],
): string[] => {
	if (!rs || !map || !selected || selected.length === 0) {
		return [];
	}

	const codes = map.get(rs.toLowerCase());

	if (!codes || codes.length === 0) {
		return [];
	}

	return selected.filter((code) => codes.indexOf(code) !== -1);
};

// The >= 2 guard keeps a non-carrier (rf 1) unmodified as the legacy did, and makes any future
// drift between QS_base zygosity and genestage risk a no-op rather than a wrong colour.
export const applyModifier = (numericRiskFactor: number, isModified: boolean): number =>
	isModified && numericRiskFactor >= 2 ? numericRiskFactor - 1 : numericRiskFactor;

// Bottom-up rollup, not the legacy's last-writer-wins ancestor walk at brightstarD3.js:268-273.
export const rollupModifiedCount = (node: WheelNode): number => {
	if (node.type === "snp") {
		const count = node.modifiedBy && node.modifiedBy.length > 0 ? 1 : 0;
		node.modifiedCount = count;
		return count;
	}

	const count = (node.children || []).reduce((total, child) => total + rollupModifiedCount(child), 0);
	node.modifiedCount = count;

	return count;
};
